<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        data-follow-fill="currentColor"
        d="M670.9 72.5c112.3 0 203.8 90.1 205.6 202.3l.1 3.4v197c0 6.4-5.1 11.4-11.4 11.4h-59.5c-3 0-5.9-1.2-8.1-3.3-2.1-2.1-3.3-5-3.3-8.1V278.3c0-67.4-54.1-122.4-121.4-123.5H277.8c-67.4 0-122.4 54.1-123.5 121.4v472.1c0 65.3 52.4 118.6 117.7 119.7h210.6c6.3 0 11.4 5.1 11.4 11.4v59.5c0 6.3-5.1 11.4-11.4 11.4H274c-110.2 0-200.1-88.4-201.9-198.7l-.1-3.2V278.2c0-112.3 90-203.8 202.3-205.7h396.6zM438 670.6v56.5c0 7.1-5.1 12.9-11.5 12.9H270.9c-3.1 0-6-1.4-8-3.7-2.2-2.5-3.5-5.8-3.4-9.1v-56.6c0-7 5.1-12.8 11.5-12.8h155.7c6.2-.1 11.3 5.7 11.3 12.8zM682.3 292c6.3 0 11.4 5.8 11.4 12.9v56.5c0 7.1-5.1 12.9-11.4 12.9H270.9c-3.1-.1-6-1.4-8-3.8-2.2-2.5-3.4-5.7-3.4-9.1v-56.5c0-7.1 5.1-12.9 11.5-12.9h411.3zm128 316.6c6.3 0 11.4 5.1 11.4 11.4v118.9h118.9c6.3 0 11.4 5.1 11.4 11.5v59.4c0 6.3-5.1 11.4-11.4 11.4H821.7V940c0 6.4-5.1 11.5-11.4 11.5h-59.5c-3 0-6-1.2-8.1-3.4-2.1-2.2-3.3-5.1-3.3-8.1V821.1H620.6c-3 0-5.9-1.2-8.1-3.3-2.1-2.1-3.3-5-3.3-8.1v-59.4c0-6.4 5.1-11.5 11.4-11.5h118.9V620c0-6.3 5.1-11.4 11.4-11.4h59.4zm-128-133.8c6.3 0 11.4 5.8 11.4 12.9v56.5c0 7.1-5.1 12.9-11.4 12.9H270.9c-3.1-.1-6-1.4-8-3.8-2.2-2.5-3.4-5.7-3.4-9.1v-56.5c0-7.1 5.1-12.9 11.5-12.9h411.3zm0 0"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
